import { Cube } from "@phosphor-icons/react";

// Branded header strip for blueprint/print views. Falls back to MODUS when no logo/org set.
export function BrandHeader({ branding }) {
  const b = branding || {};
  if (!b.organization_name && !b.logo_url) return null;
  return (
    <div data-testid="brand-header" className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-200">
      {b.logo_url ? (
        <img src={b.logo_url} alt="" data-testid="brand-logo" className="h-9 max-w-[160px] object-contain" />
      ) : (
        <Cube size={28} weight="duotone" className="text-indigo-500" />
      )}
      {b.organization_name && (
        <span className="font-semibold text-slate-900 tracking-tight" data-testid="brand-org-name">{b.organization_name}</span>
      )}
    </div>
  );
}

export function BrandFooter({ branding, fallback }) {
  const b = branding || {};
  const org = b.organization_name || "";
  const footer = b.custom_footer_text || "";
  if (!org && !footer) {
    return (
      <div className="mt-8 pt-4 border-t border-slate-200 font-mono text-xs text-slate-400" data-testid="brand-footer">
        {fallback || "Generated with MODUS"} · {new Date().toLocaleDateString()}
      </div>
    );
  }
  return (
    <div className="mt-8 pt-4 border-t border-slate-200 font-mono text-xs text-slate-500 flex flex-wrap items-center justify-between gap-2" data-testid="brand-footer">
      <span>{org}</span>
      <span className="text-slate-400">{footer}</span>
    </div>
  );
}
